module.exports = __webpack_public_path__ + "classic-chrome-selector.c3e8349d75825ebb5e2d.png";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/classic-chrome-selector.png
// module id = ../../../../../src/assets/img/classic-chrome-selector.png
// module chunks = main